export default __webpack_public_path__ + "static/media/sheep_spritesheet.83deb83b.png";